import { ITextboxProps } from '../textbox';
import { IBaseComponentProps } from '../types';

export interface ITimePickerProps extends Omit<React.HTMLProps<HTMLInputElement>, 'as' | 'ref' | 'type' | 'onChange'>, IBaseComponentProps<HTMLInputElement>, Pick<ITextboxProps, 'clearIconTitle' | 'error'> {
  /**
   * Disable time picker
   */
  disabled?: boolean;
  /**
   * Time picker hour step
   */
  hourStep?: number;
  /**
   * Is time picker 12 hour format
   */
  is12Hour?: boolean;
  /**
   * Show seconds for time picker
   */
  showSecond?: boolean;
  /**
   * Time picker minute step
   */
  minuteStep?: number;
  /**
   * Time picker second step
   */
  secondStep?: number;
  /**
   * Time seperator string
   */
  timeSeparator?: string;
  /**
   * Value of time picker
   */
  value?: string;
  /**
   * Default value of time picker
   */
  defaultValue?: string;
  /**
   * Hide clear icon
   */
  hideClearIcon?: boolean;
  /**
   * On change handler
   */
  onChange?: (time: string) => void;
}

export enum Meridiem {
  AM = 'AM',
  PM = 'PM'
}
